"use client";

import ProductCard from "@/components/product-card";
import { ProductType } from "@/types/product.type";
import { Card } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

export default function SimilarProducts({
  products,
}: {
  products: ProductType[];
}) {
  if (products.length == 0) return null;

  return (
    <Card>
      <div className="flex items-center justify-between gap-3 px-4 py-4">
        <div className="text-xl font-semibold">Similar Products</div>
      </div>
      <div>
        <Swiper
          modules={[Autoplay, Navigation]}
          autoplay={{ delay: 2500, disableOnInteraction: false }}
          spaceBetween={16}
          slidesPerView="auto"
          loop
          navigation
          slidesOffsetBefore={24}
          slidesOffsetAfter={24}
        >
          {products.map((product, index) => (
            <SwiperSlide
              className="md:max-w-[300px] max-w-[165px] pb-8"
              key={index}
            >
              <ProductCard product={product} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </Card>
  );
}
